const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  pageHeaderWrap: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    borderRadius: "15px",
  },
  formHeader: {
    display: "flex",
    alignItems: "center",
  },
  backIcon: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    padding: "5px 8px",
    borderRadius: "8px",
    cursor: "pointer",
    backgroundColor: "#fff",
  },
  header: {
    ...theme.typography.h1,
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: "18px",
    fontWeight: 600,
  },
  headerContainer: {
    width: "100%",
    marginBottom: "16px",
  },
  breadcrumbsWrap: {
    display: "flex",
    justifyContent: "flex-end",
  },
  headerRightWrap: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexShrink: 0,
  },
  breadcrumbItem: {
    fontWeight: 500,
    color: "#222B45",
    fontSize: "14px",
    textDecoration: "none",
    cursor: "pointer",
    transition: "color 0.2s",
    fontFamily: "Inter, system-ui, sans-serif",
  },
  breadcrumbActive: {
    fontWeight: 600,
    color: "#2563eb",
    fontSize: "14px",
    textDecoration: "none",
    cursor: "default",
    fontFamily: "Inter, system-ui, sans-serif",
  },
  breadcrumbSeparator: {
    color: "#B0B7C3",
    fontWeight: 400,
    fontSize: "1.2em",
    margin: "0 0.5em",
  },
}));
